const path = '/emoji';
const canonicalEmojiMap: {
  [key: string]: { longname: string; shortnames: string[] };
} = {
  slightly_smiling_face: {
    longname: ':slightly_smiling_face:',
    shortnames: [':)'],
  },
  smile: {
    longname: ':smile:',
    shortnames: [':D'],
  },
  smiley: {
    longname: ':smiley:',
    shortnames: ['=D'],
  },
  upside_down_face: {
    longname: ':upside_down_face:',
    shortnames: [],
  },
  stuck_out_tongue: {
    longname: ':stuck_out_tongue:',
    shortnames: [':p', ':P'],
  },
  sunglasses: {
    longname: ':sunglasses:',
    shortnames: ['B)'],
  },
  thinking_face: {
    longname: ':thinking_face:',
    shortnames: [],
  },
  white_frowning_face: {
    longname: ':white_frowning_face:',
    shortnames: [':('],
  },
  cry: {
    longname: ':cry:',
    shortnames: [":'("],
  },
  sob: {
    longname: ':sob:',
    shortnames: [],
  },
  angry: {
    longname: ':angry:',
    shortnames: ['>:[', '&gt;:['],
  },
  rage: {
    longname: ':rage:',
    shortnames: [],
  },
  ok: {
    longname: ':ok:',
    shortnames: [],
  },
  thumbsup: {
    longname: ':thumbsup:',
    shortnames: ['+1'],
  },
  clap: {
    longname: ':clap:',
    shortnames: [],
  },
  heart: {
    longname: ':heart:',
    shortnames: ['&lt;3', '<3'],
  },
};

const emojiKeyToImageMap: { [key: string]: string } = {};
const emojiLongnameToImageMap: { [key: string]: string } = {};
const emojiLongnameList: string[] = [];
const emojiShortnameList: string[] = [];

Object.keys(canonicalEmojiMap).forEach(key => {
  const emojiDetails = canonicalEmojiMap[key];
  const emojiLongname = emojiDetails.longname;
  const cdnEmojiUrl = `${path}/${key}.png`;

  emojiLongnameList.push(emojiLongname);
  emojiLongnameToImageMap[emojiLongname] = cdnEmojiUrl;
  emojiKeyToImageMap[emojiLongname] = cdnEmojiUrl;
  emojiDetails.shortnames.forEach((name: string) => {
    emojiKeyToImageMap[name] = cdnEmojiUrl;
    emojiShortnameList.push(name);
  });
});

export {
  emojiLongnameToImageMap,
  emojiKeyToImageMap,
  emojiLongnameList,
  emojiShortnameList,
};



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/es/webapp/src/app/@shared/ui/emoji/map.ts